var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from '../infoDialog/infoDialog.module.css';
import { IconButton } from '../../buttons/iconButton/IconButton';
import { Button } from '../../buttons/button/Button';
import clsx from 'clsx';
import { Icons, IconSizes } from '../../icons/icons';
export var AlertDialog = forwardRef(function (_a, ref) {
    var title = _a.title, content = _a.content, _b = _a.type, type = _b === void 0 ? 'info' : _b, _c = _a.closeText, closeText = _c === void 0 ? 'Close' : _c, _d = _a.closeButtonType, closeButtonType = _d === void 0 ? 'outline' : _d, _e = _a.confirmText, confirmText = _e === void 0 ? 'Ok' : _e, _f = _a.border, border = _f === void 0 ? false : _f, onClose = _a.onClose, _g = _a.canClose, canClose = _g === void 0 ? true : _g;
    var handleClick = function (e, state) {
        e.stopPropagation();
        onClose(state);
    };
    return (_jsxs("dialog", __assign({ className: clsx(styles.dialog, border && styles["dialogBorder__".concat(type)]), ref: ref }, { children: [_jsx("p", __assign({ className: styles.title }, { children: title })), _jsx("p", __assign({ className: styles.content }, { children: content })), _jsxs("form", __assign({ method: "dialog" }, { children: [_jsx("div", __assign({ className: styles.close }, { children: canClose && (_jsx(IconButton, { icon: Icons.CROSS, type: 'clear', size: IconSizes.XXS, onClick: function () {
                                onClose('close');
                            } })) })), _jsxs("div", __assign({ className: styles.buttons }, { children: [canClose && (_jsx(Button, { label: closeText, type: closeButtonType, onClick: function (e) { return handleClick(e, 'abort'); } })), _jsx(Button, { label: confirmText, type: type, onClick: function (e) { return handleClick(e, 'confirm'); } })] }))] }))] })));
});
export default AlertDialog;
